import React from 'react';
import clsx from 'clsx';
import { TFunction } from 'next-i18next';
import { Field, ErrorMessage, FormikTouched } from 'formik';
import { SellerFormValueType as FormValueType } from '@interfaces/models/seller-info/seller-information';
import Icon from '@components/atoms/icon/icon';
import styles from '@components/seller-information/seller-information-form/seller-information-form.module.scss';

type SellerFormTextInputProps = {
  name: string;
  label: string;
  value: string;
  placeholder?: string;
  required: boolean;
  maxLength?: number;
  t: TFunction;
  dirty?: boolean;
  touched?: FormikTouched<FormValueType>;
};

const SellerFormTextInput: React.FC<SellerFormTextInputProps> = (props): React.ReactElement => {
  const { name, label, value, placeholder, required, maxLength, t, dirty, touched } = props;
  return (
    <>
      <Field
        as="input"
        name={name}
        aria-labelledby={`label-${name}`}
        className={clsx('vc-inputText', styles['vc-inputText'], {
          [styles['vc-inputText--touched']]: dirty && touched?.[name],
        })}
        value={value}
        maxLength={maxLength}
        placeholder={placeholder}
        autoComplete="off"
        required={required}
      ></Field>
      <label
        id={`label-${name}`}
        className={clsx('vc-inputText-label', styles['vc-inputText-label'], {
          [styles.required]: required,
        })}
      >
        {label}
      </label>
      <ErrorMessage
        name={name}
        render={(message) => (
          <div className={clsx('vc-inputText-errorMsg vc-text-xs', styles.labelErrorContainer)}>
            <span className={`${styles.labelErrorContainer__icon}`}>
              <Icon
                name="warning-20"
                data-cy="error_info_icon"
                ariaHidden
              />
            </span>
            {t(message)}
          </div>
        )}
      />
    </>
  );
};

export default SellerFormTextInput;
